import React, { useEffect, useState } from "react"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { useDispatch, useSelector } from "react-redux"
import swal from "sweetalert"
import { Button, Card } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { DetailText, RowText, Status } from "../../../../../component/index.jsx"
import {
  activitySendToErp,
  getDetailSeedling,
  updateAreaActivityImage
} from "../../../../../redux/actions/AreaAction.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import {
  checkBadgePaymentStatus,
  stringFormatting,
  toMeter,
  toRupiah
} from "../../../../helpers/TextHelper.js"
import { AREA, GENERAL } from "../../../../../constants/InitTypeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { ActivityDetailHeader } from "../../../../../component/molecule/ActivityDetailHeader/ActivityDetailHeader.jsx"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { ErpNumber } from "../../../../../component/atoms/ErpNumber/ErpNumber.jsx"
import { PopupQuestion } from "../../../../../component/atoms/Popup/popupQuestion.jsx"
import {
  ACTIVITY_STATUS_ENUM,
  DATE_TYPE_ENUM,
  STATUS_VARIANT_CONSTANT
} from "../../../../../constants/StringConstant.js"
import { useTranslation } from "react-i18next"

export const SeedlingDetail = ({
  match: {
    params: { status, id, activity_id }
  }
}) => {
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { MasterData, General, Area } = useSelector((state) => state)
  const [detail, setDetail] = useState({})
  const [idDocument, setIdDocument] = useState(null)
  const [showModalDialog, setShowModalDialog] = useState(false)

  const btnApprove = (
    <Button className={"btn btn-primary"} onClick={() => setShowModalDialog(true)}>
      {t("button_send_to_finance")}
    </Button>
  )

  useEffect(() => {
    dispatch(getDetailSeedling(activity_id))
  }, [])

  useEffect(() => {
    if (Area.data) {
      setDetail(Area.data)
    }
  }, [Area])

  useEffect(() => {
    if (detail) {
      if (detail?.is_confirmed_erp === false && !detail?.is_seedling_package) {
        subHeader.setButton(btnApprove)
      } else {
        subHeader.setButton(null)
      }

      subHeader.setBreadcrumbs([
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
          title: t("label_area_name")
        },
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
          title: t("label_registered")
        },
        {
          pathname: RoutesConstants.AREA.DETAIL_AREA(status, id),
          title: detail?.activity_detail_response?.area_name
        },
        {
          title: "Semai"
        }
      ])
    }
  }, [detail])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (General.actionInitType === GENERAL.UPLOAD) {
        const data = {
          id: detail?.activity_detail_response?.image_and_id_activity[idDocument]?.id,
          url: MasterData.urlResponseUpload
        }

        dispatch(updateAreaActivityImage(data))
      } else if (General.actionInitType === AREA.UPDATE_ACTIVITY_IMAGE) {
        dispatch(getDetailSeedling(activity_id))
      } else if (
        General.loading === false &&
        General.actionInitType === AREA.APPROVE_ACTIVITY_TO_ERP
      ) {
        setShowModalDialog(false)
        swal({
          icon: ILLUSTRATION_CONSTANTS.SUCCESS_FORM,
          text: t("messages_response_activity_approve_to_erp_success")
        })
        dispatch(getDetailSeedling(activity_id))
      }
    }
  }, [General])

  const titleActivity = (
    <ActivityDetailHeader
      icon={ICON_CONSTANTS.ACTIVITY_ICONS.SEEDLING}
      title={` AKTIVITAS ${
        detail?.is_seedling_package
          ? `SEMAI ${t("label_seedling_package")}`.toUpperCase()
          : `Semai KE-${detail?.activity_detail_response?.seq}`
      }`}
      bottomContent={
        <ErpNumber
          noFaktur={detail?.no_faktur}
          noOrderSj={detail?.no_order_sj}
          noOrderSpk={detail?.no_order_spk}
          noOrderErp={detail?.no_order_erp}
          status={detail?.activity_type_enum}
        />
      }
      rightContent={
        !detail?.is_seedling_package &&
        detail?.is_confirmed_erp !== null && (
          <Status
            text={detail?.status_activity_string}
            variant={
              detail?.status_activity_enum === ACTIVITY_STATUS_ENUM.APPROVED
                ? STATUS_VARIANT_CONSTANT.COMPLETED
                : STATUS_VARIANT_CONSTANT.WARNING
            }
          />
        )
      }
    />
  )

  const bills = (
    <Card className={"mb-4"}>
      <CardBody>
        <div className={"d-flex justify-content-between align-items-center"}>
          <h4 className={"mb-6 text-uppercase"}>{t("details_bill")}</h4>
          {checkBadgePaymentStatus(detail?.billing_detail?.payment_status, "mb-6")}
        </div>
        <Card bg={"secondary"}>
          <CardBody className={"px-8 py-6"}>
            <RowModule customColumnCss={"col-md-6"} withoutSeparator={true}>
              <RowText
                label={t("total_bills")}
                value={toRupiah(detail?.billing_detail?.total_bill)}
              />
              <RowText
                label={t("remaining_bill")}
                value={toRupiah(detail?.billing_detail?.remaining_bill)}
              />
              <RowText
                label={t("already_paid")}
                value={toRupiah(detail?.billing_detail?.paid_amount)}
              />
              <RowText
                label={t("paid_date")}
                value={stringFormatting(
                  timeStampToDate(detail?.billing_detail?.paid_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
                )}
              />
            </RowModule>
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  )

  const detailActivitas = (
    <>
      <Card>
        <CardBody>
          <h4 className={"mb-6 text-uppercase"}>INFORMASI LAHAN</h4>
          <RowModule customColumnCss={"col-md-6 mb-2"}>
            <RowModule>
              <RowText
                label={t("label_area_name")}
                value={stringFormatting(detail?.area_information?.area_name)}
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_manual_area_size")}
                value={
                  detail?.area_information?.area_land_manual
                    ? toMeter(detail?.area_information?.area_land_manual)
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                hasIcon={detail?.area_information?.has_kur}
                icon={detail?.area_information?.bank_image}
                label={t("label_farmer")}
                value={
                  detail?.area_information?.farmer_name
                    ? `${detail?.area_information?.farmer_name} (${detail?.area_information?.farmer_code})`
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_polygon_area_size")}
                value={
                  detail?.area_information?.area_land_polygon
                    ? toMeter(detail?.area_information?.area_land_polygon)
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_mitra")}
                value={
                  detail?.area_information?.mitra_name
                    ? `${detail?.area_information?.mitra_name} (${detail?.area_information?.mitra_code})`
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_plant_type")}
                value={stringFormatting(detail?.area_information?.plant_type_name)}
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_area_location")}
                value={stringFormatting(detail?.area_information?.full_address)}
              />
            </RowModule>
          </RowModule>
        </CardBody>
      </Card>

      <Card>
        {" "}
        <CardBody>
          <h4 className={"mb-6 mt-6 text-uppercase"}>Detail Aktivitas</h4>
          <RowModule customColumnCss={"col-md-6 mb-2"}>
            <RowModule customColumnCss={"col-md-12 mb-2"} filterChildren>
              <RowModule>
                <RowText
                  label={"Submitted by"}
                  value={stringFormatting(detail?.activity_detail_response?.submitted_by)}
                />
              </RowModule>
              <RowModule>
                <RowText
                  label={"Submitted time"}
                  value={
                    detail?.activity_detail_response?.submitted_date
                      ? timeStampToDate(
                          detail?.activity_detail_response?.submitted_date,
                          "dd-MM-yyyy HH:mm:ss"
                        )
                      : "-"
                  }
                />
              </RowModule>

              {!detail?.is_seedling_package && (
                <RowModule>
                  <RowText
                    label={"Semai ke"}
                    value={stringFormatting(detail?.activity_detail_response?.seq)}
                  />
                </RowModule>
              )}
              <RowModule>
                <RowText
                  label={"Tanggal Aktivitas"}
                  value={
                    detail?.activity_detail_response?.activity_date
                      ? timeStampToDate(
                          detail?.activity_detail_response?.activity_date,
                          "dd-MM-yyyy"
                        )
                      : "-"
                  }
                />
              </RowModule>
              <RowModule>
                <RowText
                  label={"HST"}
                  value={stringFormatting(detail?.activity_detail_response?.hst, "HST")}
                />
              </RowModule>
            </RowModule>
            <RowModule customColumnCss={"col-md-12 mb-2"} filterChildren>
              <RowModule>
                <RowText label={"Asal Benih"} value={stringFormatting(detail?.seed_source_name)} />
              </RowModule>
              <RowModule>
                <RowText
                  label={"Jenis Varietas"}
                  value={stringFormatting(detail?.area_information?.variety_name)}
                />
              </RowModule>
              <RowModule>
                <RowText
                  label={"Jumlah Benih"}
                  value={detail?.seed_qty ? `${detail?.seed_qty} Kg` : "-"}
                />
              </RowModule>
              <RowModule>
                <RowText
                  label={"Jenis Persemaian"}
                  value={stringFormatting(detail?.seed_method_string)}
                />
              </RowModule>
              <RowModule>
                <RowText
                  label={"Kepemilikan Alsintan"}
                  value={stringFormatting(detail?.owner_tool_string)}
                />
              </RowModule>
            </RowModule>
          </RowModule>

          <div className={"my-10"}>
            <h4 className={"mb-6"}>CATATAN</h4>
            <div className={"row mb-4"}>
              {detail?.activity_detail_response?.image_and_id_activity &&
                detail?.activity_detail_response?.image_and_id_activity.map((item, index) => {
                  return (
                    <div className={"col-md-3"} key={index}>
                      <DetailText
                        type="image"
                        value={item.url}
                        indexKey={index}
                        menu={AREA.ACTIVITY_SEEDLING}
                        setIdDocument={setIdDocument}
                      />
                    </div>
                  )
                })}
            </div>
            <span className="font-weight-bold text-dark-50 font-size-sm">
              {stringFormatting(detail?.activity_detail_response?.note)}
            </span>
          </div>
        </CardBody>
      </Card>
    </>
  )

  return (
    <>
      <div className={"d-flex flex-column"} style={{ gap: 12 }}>
        {titleActivity}
        {detail?.billing_detail?.payment_status && bills}
        {detailActivitas}
      </div>
      <PopupQuestion
        onCancel={() => setShowModalDialog(false)}
        textCancel={t("button_cancel")}
        textOk={t("button_continue")}
        title={t("messages_title_activity_send_to_erp")}
        onOk={() => {
          dispatch(activitySendToErp(activity_id, {}))
          setShowModalDialog(false)
        }}
        show={showModalDialog}
        bodyCustom={
          <RowModule>
            <p className={"swal-text p-4"}>
              {t("messages_confirmation_activity_approve_to_erp_confirmation")}
            </p>
          </RowModule>
        }
      />
    </>
  )
}